import React from "react";
import './Home.css'
import pastorImage from '../../images/pastor.jpg'
import bannerImage1 from '../../images/banner-a.jpg'
import bannerImage2 from '../../images/banner-b.jpg'
import bannerImage3 from '../../images/banner-c.jpg'
import onlineBibleImage from '../../images/home-image-button-online-bible.jpg'
import onlineDonationsImage from '../../images/home-image-button-online-donations.jpg'
import childrenMinistryImage from '../../images/home-image-button-children-ministry.jpg'
import youthMinistryImage from '../../images/home-image-button-youth-ministry.jpg'
import {Carousel} from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import {Church, EventAvailable, PhotoCamera, RecordVoiceOver} from "@mui/icons-material";
import {Button} from "../Button";
import Footer from "../Footer";
import {ClickHereImageButton} from "../ClickHereImageButton";

function Home() {
    return (
        <>
            <Header/>
            <Welcome/>
            <ImageSlider/>
            <ClickHereIcons/>
            <ClickHereImageButtons/>
            <YoutubeWelcome/>
            <ContactUsServiceTimes/>
            <Footer/>
        </>
    )
}

function Header() {
    return (
        <div className='home-header'>
            <div className='home-header-image'/>
            <div className='home-header-overlay'/>
            <div className='header-content'>
                <h1>Ekklesia Ministries</h1>
                <Button className='btns' buttonLink='church-history' buttonSize='btn--medium'>LEARN MORE</Button>
            </div>
        </div>
    )
}

function Welcome() {
    return (
        <div className='home-welcome'>
            <div className='home-welcome-container'>

                <div className='home-welcome-image-container'>
                    <img src={pastorImage} alt="Italian Trulli"/>
                </div>

                <div className='home-welcome-text'>
                    <h1>Welcome</h1>
                    <p>Ekklesia is a cutting edge ministry located in the heart of the Shoals Area (Sheffield, AL) and
                        in Corinth, MS. Each worship experience features blended worship that touches all ethnicity and
                        ages. We assure that you will receive a warm welcome, a relevant word, and a wonderful
                        experience in God’s presence a midst God’s people. Please feel free to join us in any of our
                        worship services, small groups, or our outreach activities.</p>
                </div>

            </div>
        </div>
    )
}

function ImageSlider() {
    return (
        <div className='home-image-slider-container'>
            <div className='home-image-slider'>
                <Carousel autoPlay infiniteLoop showThumbs={false} showStatus={false} showArrows={false}
                          transitionTime={750}>
                    <img src={bannerImage1} alt="banner 1"/>
                    <img src={bannerImage2} alt="banner 2"/>
                    <img src={bannerImage3} alt="banner 3"/>
                </Carousel>
            </div>
        </div>
    )
}

function ClickHereIcons() {
    return (
        <div className='click-here-icons-container'>
            <ClickHereIcon title={'Prayer Request'} linkPath={'prayer-request'}
                           iconClass={<RecordVoiceOver sx={{fontSize: 60}} style={{color: '#7F0000'}}/>}/>
            <ClickHereIcon title={'Events Calendar'} linkPath={'events'}
                           iconClass={<EventAvailable sx={{fontSize: 60}} style={{color: '#7F0000'}}/>}/>
            <ClickHereIcon title={'Photo Gallery'} linkPath={'photo-gallery'}
                           iconClass={<PhotoCamera sx={{fontSize: 60}} style={{color: '#7F0000'}}/>}/>
            <ClickHereIcon title={'Church History'} linkPath={'church-history'}
                           iconClass={<Church sx={{fontSize: 60}} style={{color: '#7F0000'}}/>}/>
        </div>
    )
}

const ClickHereIcon = ({title, linkPath, iconClass}) => {
    return (
        <div className='click-here-column'>
            {iconClass}
            <h3>{title}</h3>
            <Button className='btns' buttonLink={linkPath} buttonSize='btn--medium'>CLICK HERE</Button>
        </div>
    )
}

function ClickHereImageButtons() {
    return (
        <div className='image-buttons-container'>
            <ClickHereImageButton title='Online Bible' linkPath='test' imagePath={onlineBibleImage}/>
            <ClickHereImageButton title='Online Donations' linkPath='test' imagePath={onlineDonationsImage}/>
            <ClickHereImageButton title='Youth Ministry' linkPath='test' imagePath={youthMinistryImage}/>
            <ClickHereImageButton title='Children Ministry' linkPath='test' imagePath={childrenMinistryImage}/>
        </div>
    )
}

function YoutubeWelcome() {
    return (
        <div className='welcome-video-container'>
            <iframe src="https://www.youtube.com/embed/8pLqhScR1OA"
                    title="YouTube video player" frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen/>
        </div>
    )
}

function ContactUsServiceTimes() {
    return (
        <div className='contact-us-service-time-container'>
            <div className='contact-us-service-time-content'>
                <div className='contact-us-content'>
                    <h2>Contact Us</h2>
                    <p>We have two locations:</p>
                    <p>3007 Hatch Blvd. <br/> Sheffield, Alabama 35660</p>
                    <p>And also:</p>
                    <p>2066 S. Tate Street <br/> Corinth, Mississippi, 38873</p>
                    <p>Phone: (256) 314-1700</p>
                </div>
                <div className='service-times-content'>
                    <h2>Service Times</h2>
                    <p>Sunday Morning Worship <br/>Sheffield, AL - 10:00 am<br/>Corinth, MS - 9:00 am</p>
                    <p>Insight Bible Sunday<br/>Sheffield, AL - Wednesday 7:00 pm<br/>Corinth, MS - Wednesday 7:00 pm
                    </p>
                    <iframe title='Ekklessia Missionary Baptist - Sheffield' loading="lazy" allowFullScreen
                            src="https://www.google.com/maps/embed/v1/place?q=place_id:ChIJ2UHgm7xIfYgRw997dEO2JFg&key=AIzaSyCRnwaAA0DGEr7iOHCCZcxFrU3j9GJfMj4&zoom=10"/>

                </div>
            </div>
        </div>
    )
}

export default Home;
